<template>
  <div>
    <div class="chi" v-for="(item, index) in new Array(10).fill({})" :key="index">
      <div class="img-wrapper">
        <CySkeletonShape class="img"></CySkeletonShape>
      </div>
      <div class="content">
        <div class="show">
          <CySkeletonLine height="20"></CySkeletonLine>
        </div>
        <div class="venue">
          <CySkeletonLine height="20"></CySkeletonLine>
        </div>
        <div class="session">
          <CySkeletonLine height="20"></CySkeletonLine>
        </div>
        <!--TODO: 无字段-->
        <div class="tag-wrapper">
          <CySkeletonLine height="20"></CySkeletonLine>
        </div>
        <div class="bottom">
          <div class="price">
            <CySkeletonLine height="20" width="63"></CySkeletonLine>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import url("@/assets/css/skeleton.less");

.chi {
  display: flex;
  cursor: pointer;
  padding: 28px;

  .img-wrapper {
    width: 164px;
    height: 220px;

    .img {
      width: 148px;
      height: 196px;
    }
  }

  .content {
    width: 100%;
    border-bottom: 1px solid var(--vt-c-white-soft);
    display: flex;
    margin-left: 16px;
    flex-direction: column;

    .show {
      width: 660px;
      height: auto;
      max-height: 40px;
      font-size: 16px;
      .text-ellipsis(2);
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-bottom: 12px;
    }

    .venue {
      width: 280px;
      height: 18px;
      font-size: 14px;
      .text-ellipsis(1);
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .session {
      width: 160px;
      height: 18px;
      font-size: 14px;
      .text-ellipsis(1);
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      margin-bottom: 12px;
    }

    .tag-wrapper {
      width: 38px;
      height: 20px;
      display: flex;
      align-items: center;
      line-height: 20px;
      text-align: center;
      color: #333333;

      div {
        width: 36px;
        height: 10px;
        -webkit-transform: scale(0.8);
        font-size: 10px;
        font-weight: 400;
        color: #333333;
        line-height: 10px;
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: end;
      margin-top: auto;
      margin-bottom: 20px;

      .price {
        display: flex;
        align-items: baseline;

        .unit {
          width: 8px;
          height: 16px;
          font-size: 14px;

          font-weight: 500;
          color: #ff562e;
          line-height: 16px;
        }

        .number {
          width: auto;
          height: 26px;
          font-size: 24px;

          font-weight: 500;
          color: #ff562e;
          line-height: 26px;
          padding-left: 3px;
        }

        .text {
          margin-left: 2px;
          width: 14px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 14px;
        }
      }

      .btn {
        display: flex;
        width: 104px;
        height: 46px;
        background: #A9823E;
        align-items: center;
        /*垂直方向居中*/
        justify-content: center;
        /*水平方向居中*/

        .text {
          width: 48px;
          height: 22px;
          font-size: 16px;
          font-weight: 600;
          color: var(--vt-c-white);
          line-height: 22px;
        }
      }
    }
  }
}
</style>
